import { useMemo } from "react";
import { apiV2 } from "@/lib/apiV2/apiV2";
import { useQuery } from "@tanstack/react-query";

export const useUserApplicationsV2 = () => {
  const {
    data: applicationsData,
    error: applicationsError,
    isLoading: loadingApplications,
  } = useQuery({
    queryKey: ["applicationsV2"],
    queryFn: apiV2.applications.getAll,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  const applications = applicationsData?.data || [];

  const applicationOptions = useMemo(
    () =>
      applications.map((app) => ({
        label: app.name,
        value: app.id,
      })),
    [applications]
  );

  return {
    applications,
    applicationsError,
    loadingApplications,
    applicationOptions,
  };
};
